import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { Phone } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import style from './style.scss';

const NeedHelpModal = () => {
  const modalRef = useRef();
  const [isModal, setIsModal] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsModal(false);
      }
    };

    if (isModal) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isModal]);

  const toggleModal = () => {
    setIsModal(!isModal);
  };

  return (
    <>
      <a href="#" onClick={toggleModal} className="text-gray-700 hover:text-gray-900 hover:no-underline">
        Need help?
      </a>
      <div className={cn('reveal', style.reveal, !isModal && style.invisible)}>
        <div className={style.modalCard}>
          <Card className="shadow-none border-none" ref={modalRef}>
            <CardHeader className="text-left p-0 pt-1">
              <CardTitle className="text-2xl">Need Help</CardTitle>
              <CardDescription className="text-lg text-gray-600">Contact a Live Agent</CardDescription>
            </CardHeader>
            <CardContent className="pt-4 pb-2">
              <div className="text-center">
                <div className="inline-block p-4 bg-green-100 rounded-full mb-6">
                  <Phone className="h-8 w-8 text-green-500" />
                </div>
                <div className="space-y-4">
                  <p className="text-lg">Call us at:</p>
                  <p className="text-3xl font-bold text-green-500">(949) 694-5001</p>
                  <div className="text-gray-600 space-y-1">
                    <p>Available Monday - Friday</p>
                    <p>6:00 AM - 5:00 PM PST</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
          <button style={{ fontSize: '1.5rem' }} className="close-button" data-close aria-label="Close reveal" type="button" onClick={toggleModal}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default NeedHelpModal;
